import React from 'react';
import { Modal as BSModal } from 'react-bootstrap';
import type { ModalProps } from '../../types/common';

/**
 * Base Modal component built on React Bootstrap
 * Provides consistent modal behavior across the application
 */
export const Modal: React.FC<ModalProps> = ({
  show,
  onHide,
  title,
  size,
  backdrop = true,
  centered = false,
  children,
  className = '',
  id,
  'data-testid': testId,
  ...props
}) => {
  return (
    <BSModal
      show={show}
      onHide={onHide}
      size={size}
      backdrop={backdrop}
      centered={centered}
      className={className}
      id={id}
      data-testid={testId}
      {...props}
    >
      {title && (
        <BSModal.Header closeButton>
          <BSModal.Title>{title}</BSModal.Title>
        </BSModal.Header>
      )}
      <BSModal.Body>
        {children}
      </BSModal.Body>
    </BSModal>
  );
};

/**
 * Modal with predefined header and footer structure
 */
export interface StructuredModalProps extends ModalProps {
  footer?: React.ReactNode;
  hideCloseButton?: boolean;
}

export const StructuredModal: React.FC<StructuredModalProps> = ({
  show,
  onHide,
  title,
  size,
  backdrop = true,
  centered = false,
  children,
  footer,
  hideCloseButton = false,
  className = '',
  id,
  'data-testid': testId,
  ...props
}) => {
  return (
    <BSModal
      show={show}
      onHide={onHide}
      size={size}
      backdrop={backdrop}
      centered={centered}
      className={className}
      id={id}
      data-testid={testId}
      {...props}
    >
      {title && (
        <BSModal.Header closeButton={!hideCloseButton}>
          <BSModal.Title>{title}</BSModal.Title>
        </BSModal.Header>
      )}
      
      <BSModal.Body>
        {children}
      </BSModal.Body>
      
      {footer && (
        <BSModal.Footer>
          {footer}
        </BSModal.Footer>
      )}
    </BSModal>
  );
};

export default Modal;
